import { Component, signal, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';
import { WebSocketService } from './services/websocket.service';
import { AuthService } from './services/auth.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ConfirmationDialogComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App implements OnInit {
  protected readonly title = signal('LaBase_Admin');

  private websocketService = inject(WebSocketService);
  private authService = inject(AuthService);

  ngOnInit() {
    this.initializeWebSocket();
  }

  /**
   * Initialise la connexion WebSocket si l'utilisateur est connecté
   * Cette méthode est appelée au démarrage de l'application pour maintenir
   * la connexion WebSocket même après un refresh
   */
  private async initializeWebSocket() {
    const token = this.authService.getToken();
    if (token) {
      try {
        await this.websocketService.connect(token);
        console.log('[App Admin] WebSocket connecté au démarrage de l\'application');
      } catch (error) {
        console.error('[App Admin] Erreur lors de la connexion WebSocket:', error);
      }
    }
  }
}
